import React from "react";

const Forms = () => {
  return <div>Forms</div>;
};

export default Forms;
